export default __webpack_public_path__ + "static/media/1447.5ea07a3c.png";